import { useDisclosure } from "@chakra-ui/react";

export const useFeedback = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return { isOpen, onOpen, onClose };
};
